export default __webpack_public_path__ + "static/4-sea-to-sky-label-d1c47c5f70a90dd783fc9def1732deec.svg";